import Axios from 'axios';
import { apiUrl } from '../environment';
import { store } from '../store/store';
import { logout } from '../slice/authSlice';

function authRequestInterceptor(config) {
    const token = store.getState()?.auth?.user?.token;
    if (token) {
        config.headers.authorization = `${token}`;
    }
    config.headers.Accept = 'application/json';
    return config;
}

export const axiosApi = Axios.create({
    baseURL: apiUrl,
});

axiosApi.interceptors.request.use(authRequestInterceptor);
axiosApi.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response?.status === 403 || error.response?.status === 401) {
            console.log('>>>Successfully logout')
            localStorage.setItem('accessToken', '')
            localStorage.setItem('users', '')
            store.dispatch(logout());
            //window.location.href = '/';
        }
        return Promise.reject(error);
    }
);
